<template>
  <el-header class="header">
    <div
      v-if="isShowHomePageButton"
      class="homePage"
      @click="routeToHomePage"
    >
      <div class="homeTrigger">
        <IconSvg
          class="homeIcon"
          icon-style="icon"
          icon-class="icon-shouye1"
        />
      </div>
    </div>
    <div class="headerBrand">
      <span class="headerBrandText">LORDKY 记账</span>
    </div>
    <div class="loginOut" ref="headerDropdownRoot">
      <div class="headerRightBar">
        <div
          v-if="userDisplayName"
          class="userInfoContainer"
        >
          <div class="userAvatar">
            {{ userInitial }}
          </div>
          <div class="userMeta">
            <div class="userName">{{ userDisplayName }}</div>
            <div
              v-if="userInfo && userInfo.account"
              class="userSub"
            >
              {{ userInfo.account }}
            </div>
          </div>
        </div>
        <div class="settingTrigger" @click.stop="toggleDropdown">
          <IconSvg
            class="settingIcon"
            icon-style="icon"
            icon-class="icon-yonghushezhi"
          />
          <span class="settingTitle">设置</span>
        </div>
      </div>

      <transition name="headerDropdownFade">
        <div v-if="dropdownVisible" class="headerDropdownPanel">
          <div class="headerDropdownMenu">
            <div class="headerDropdownItem" @click="onSelectMenu(searchMore)">
              <div class="outDiv">
                <div class="iconContainer">
                  <IconSvg style="width: 30px; height: 30px" icon-style="icon" icon-class="icon-icon_" />
                </div>
                <div class="settingChooseTitle"><span>添加消费记录</span></div>
              </div>
            </div>
            <div class="headerDropdownItem" @click="onSelectMenu(addIncomeAmount)">
              <div class="outDiv">
                <div class="iconContainer">
                  <IconSvg style="width: 30px; height: 30px" icon-style="icon" icon-class="icon-yonghucaiwuliushuiguanli" />
                </div>
                <div class="settingChooseTitle"><span>添加收入记录</span></div>
              </div>
            </div>
            <div class="headerDropdownItem" @click="onSelectMenu(addGiftBook)">
              <div class="outDiv">
                <div class="iconContainer">
                  <IconSvg style="width: 30px; height: 30px" icon-style="icon" icon-class="icon-lipinka1" />
                </div>
                <div class="settingChooseTitle"><span>添加礼簿记录</span></div>
              </div>
            </div>
            <div class="headerDropdownItem" @click="onSelectMenu(settingCostType)">
              <div class="outDiv">
                <div class="iconContainer">
                  <IconSvg style="width: 30px; height: 30px" icon-style="icon" icon-class="icon-xifenleixingpeizhi" />
                </div>
                <div class="settingChooseTitle"><span>设置消费类型</span></div>
              </div>
            </div>
            <div class="headerDropdownItem" @click="onSelectMenu(routeToIncomeTypePage)">
              <div class="outDiv">
                <div class="iconContainer">
                  <IconSvg style="width: 30px; height: 30px" icon-style="icon" icon-class="icon-finance-connect-business-yen-two-users-icon" />
                </div>
                <div class="settingChooseTitle"><span>设置收入类型</span></div>
              </div>
            </div>
            <div class="headerDropdownItem isDanger" @click="onSelectMenu(loginOut)">
              <div class="outDiv">
                <div class="iconContainer">
                  <IconSvg style="width: 30px; height: 30px" icon-style="icon" icon-class="icon-tuichudenglulan" />
                </div>
                <div class="loginOutTitle"><span>退出登陆</span></div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </el-header>
</template>
<script>
import IconSvg from "../../components/common/IconSvg";
import { clearToken, getUserInfo } from "@/auth";

export default {
  name: "HeaderPage",
  props: {
    msg: String,
    isShowHomePageButton: {
      default: true,
    },
  },
  components: {
    IconSvg,
  },
  data() {
    return {
      userInfo: null,
      dropdownVisible: false,
    };
  },
  created() {
    const info = typeof getUserInfo === "function" ? getUserInfo() : null;
    if (info) {
      this.userInfo = info;
    }
  },
  mounted() {
    document.addEventListener("click", this.handleOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleOutsideClick);
  },
  computed: {
    userDisplayName() {
      if (!this.userInfo) return "";
      const info = this.userInfo;
      return (
        info.username ||
        info.account ||
        info.phoneNumber ||
        info.email ||
        info.serialNo ||
        ""
      );
    },
    userInitial() {
      if (!this.userDisplayName) return "";
      return this.userDisplayName.charAt(0).toUpperCase();
    },
  },
  methods: {
    toggleDropdown() {
      this.dropdownVisible = !this.dropdownVisible;
    },
    onSelectMenu(action) {
      if (typeof action === "function") {
        action();
      }
      this.dropdownVisible = false;
    },
    handleOutsideClick(event) {
      const root = this.$refs.headerDropdownRoot;
      if (!root) return;
      if (!root.contains(event.target)) {
        this.dropdownVisible = false;
      }
    },
    routeToHomePage() {
      this.$router.push("/").catch(() => {});
    },
    // 设置消费类型信息
    settingCostType() {
      this.$router.push("/costType").catch(() => {});
    },
    // 查看更多消费记录信息
    searchMore() {
      this.$router.push("/account").catch(() => {});
    },
    // 添加礼簿记录
    addGiftBook() {
      this.$router.push("/giftBook").catch(() => {});
    },
    // 添加收入记录信息
    addIncomeAmount() {
      this.$router.push("/income").catch(() => {});
    },
    routeToIncomeTypePage() {
      this.$router.push("/incomeType").catch(() => {});
    },
    loginOut() {
      clearToken();
      this.$router.replace("/login").catch(() => {});
    },
  },
};
</script>
<style lang="css">
.header {
  position: relative;
  /* 让 header 成为定位的参考容器，背景为带“财富/能量”感的暗黑科幻面板 */
  background:
    /* 左上/右上科幻能量晕光 */
    radial-gradient(circle at 6% 12%, rgba(56, 189, 248, 0.22), transparent 60%),
    radial-gradient(circle at 94% 10%, rgba(129, 140, 248, 0.2), transparent 55%),
    /* 金钱元素：几圈金色/翠绿色币环光晕 */
    radial-gradient(circle at 16% 85%, rgba(250, 204, 21, 0.22), transparent 60%),
    radial-gradient(circle at 22% 88%, rgba(34, 197, 94, 0.22), transparent 62%),
    radial-gradient(circle at 82% 82%, rgba(22, 163, 74, 0.24), transparent 62%),
    /* 细网格线，像账户面板上的数据矩阵 */
    repeating-linear-gradient(
      135deg,
      rgba(34, 197, 94, 0.11),
      rgba(34, 197, 94, 0.11) 1px,
      transparent 1px,
      transparent 9px
    ),
    repeating-linear-gradient(
      45deg,
      rgba(56, 189, 248, 0.06),
      rgba(56, 189, 248, 0.06) 1px,
      transparent 1px,
      transparent 11px
    ),
    /* 深色底部渐变，保持整体暗黑科技基调 */
    linear-gradient(135deg, #020617 0%, #020617 25%, #020617 45%, #020617 100%);
  /* 收窄阴影高度，避免视觉上“压住”下方按钮 */
  box-shadow:
    0 1px 0 rgba(148, 163, 184, 0.4),
    0 4px 16px rgba(15, 23, 42, 0.9),
    0 0 18px rgba(15, 23, 42, 0.9);
  border-bottom: 1px solid rgba(148, 163, 184, 0.45);
  height: 15vh !important;
}

.headerBrand {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
}

.headerBrandText {
  font-size: 18px;
  letter-spacing: 0.35em;
  padding-left: 0.35em;
  font-weight: 600;
  color: #e0f2fe;
  text-shadow:
    0 0 6px rgba(56, 189, 248, 0.6),
    0 0 18px rgba(56, 189, 248, 0.4),
    0 0 30px rgba(15, 23, 42, 0.9);
  opacity: 0.9;
  animation: headerBrandGlow 4s ease-in-out infinite;
}

@keyframes headerBrandGlow {
  0%, 100% {
    text-shadow:
      0 0 4px rgba(56, 189, 248, 0.5),
      0 0 12px rgba(56, 189, 248, 0.35),
      0 0 24px rgba(15, 23, 42, 0.9);
    opacity: 0.85;
  }
  50% {
    text-shadow:
      0 0 6px rgba(56, 189, 248, 0.85),
      0 0 20px rgba(56, 189, 248, 0.55),
      0 0 32px rgba(15, 23, 42, 0.9);
    opacity: 1;
  }
}

.loginOut {
  position: absolute;
  right: 30px;
  bottom: 10px;
  width: auto;
}

.headerRightBar {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.outDiv {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.iconContainer {
  display: flex;
  justify-content: center; /* 水平方向居中对齐 */
  align-items: center;
  margin-right: 8px;
}

.loginOutTitle {
  display: flex;
  align-items: center; /* 文字和图标垂直居中 */
  justify-content: center; /* 水平方向居中对齐 */
  color: rgb(179, 11, 11);
  font-weight: 800;
  font-size: 18px;
}

.settingTrigger {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 999px;
  background: radial-gradient(circle at 0 0, rgba(0, 255, 255, 0.22), transparent 55%),
    radial-gradient(circle at 100% 100%, rgba(120, 81, 169, 0.35), transparent 55%);
  border: 1px solid rgba(0, 255, 255, 0.25);
  box-shadow: 0 0 12px rgba(0, 255, 255, 0.3), 0 0 20px rgba(113, 70, 255, 0.3);
  backdrop-filter: blur(4px);
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.settingTrigger:hover {
  transform: scale(1.06);
  box-shadow: 0 0 18px rgba(0, 255, 255, 0.5), 0 0 28px rgba(113, 70, 255, 0.45);
  border-color: rgba(0, 255, 255, 0.5);
}

.settingTrigger:active {
  transform: scale(0.97);
  box-shadow: 0 0 8px rgba(0, 255, 255, 0.4), 0 0 14px rgba(113, 70, 255, 0.35);
}

.settingTrigger .settingIcon {
  width: 24px;
  height: 24px;
  transition: transform 0.2s ease;
}

.settingTrigger:hover .settingIcon {
  transform: rotate(90deg);
}

.settingTrigger .settingTitle {
  color: #e5eaf3;
  font-weight: 700;
  font-size: 14px;
  margin-left: 0;
}

.settingChooseTitle {
  display: flex;
  align-items: center; /* 文字和图标垂直居中 */
  justify-content: center; /* 水平方向居中对齐 */
  color: rgba(43, 79, 158, 0.774);
  font-weight: 800;
  margin-left: 5px;
  font-size: 18px;
}
.userInfoContainer {
  display: flex;
  align-items: center;
  margin-right: 12px;
  padding: 4px 10px;
  border-radius: 999px;
  background: radial-gradient(circle at 0 0, rgba(0, 255, 255, 0.28), transparent 55%),
  radial-gradient(circle at 100% 100%, rgba(120, 81, 169, 0.4), transparent 55%);
  border: 1px solid rgba(0, 255, 255, 0.25);
  box-shadow: 0 0 12px rgba(0, 255, 255, 0.35), 0 0 22px rgba(113, 70, 255, 0.35);
  backdrop-filter: blur(4px);
}
.userAvatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-image: linear-gradient(135deg, #111827, #06b6d4);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  color: #e0fbff;
  text-shadow: 0 0 6px rgba(0, 0, 0, 0.85);
  box-shadow: 0 0 10px rgba(6, 182, 212, 0.8);
}
.userMeta {
  display: flex;
  flex-direction: column;
  margin-left: 8px;
}
.userName {
  font-size: 13px;
  line-height: 1.2;
  color: #e5eaf3;
}
.userSub {
  font-size: 11px;
  line-height: 1.2;
  color: rgba(173, 214, 255, 0.78);
}
.homePage {
  cursor: pointer;
}

.homeTrigger {
  margin-top: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 14px;
  border-radius: 999px;
  background: radial-gradient(circle at 0 0, rgba(0, 255, 255, 0.22), transparent 55%),
    radial-gradient(circle at 100% 100%, rgba(120, 81, 169, 0.35), transparent 55%);
  border: 1px solid rgba(0, 255, 255, 0.25);
  box-shadow: 0 0 12px rgba(0, 255, 255, 0.3), 0 0 20px rgba(113, 70, 255, 0.3);
  backdrop-filter: blur(4px);
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.homeTrigger:hover {
  transform: scale(1.06);
  box-shadow: 0 0 18px rgba(0, 255, 255, 0.5), 0 0 28px rgba(113, 70, 255, 0.45);
  border-color: rgba(0, 255, 255, 0.5);
}

.homeTrigger:active {
  transform: scale(0.97);
  box-shadow: 0 0 8px rgba(0, 255, 255, 0.4), 0 0 14px rgba(113, 70, 255, 0.35);
}

.homeTrigger .homeIcon {
  width: 1.5vw;
  height: 1.5vw;
  max-width: 50px;
  max-height: 50px;
  min-width: 24px;
  min-height: 24px;
  color: #e5eaf3;
  transition: transform 0.2s ease;
}

.homeTrigger:hover .homeIcon {
  transform: scale(1.08);
}
</style>

<style lang="css">
.headerDropdownPanel {
  position: absolute;
  top: calc(100% + 12px);
  right: 0;
  z-index: 1000;
  width: 300px;
}

.headerDropdownMenu {
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(circle at 8% 12%, rgba(56, 189, 248, 0.2), transparent 58%),
    radial-gradient(circle at 95% 90%, rgba(129, 140, 248, 0.2), transparent 62%),
    linear-gradient(155deg, rgba(2, 6, 23, 0.98) 0%, rgba(15, 23, 42, 0.98) 42%, rgba(30, 27, 75, 0.97) 100%);
  border: 1px solid rgba(56, 189, 248, 0.35);
  box-shadow:
    0 0 0 1px rgba(56, 189, 248, 0.12),
    0 14px 34px rgba(2, 6, 23, 0.78),
    0 0 26px rgba(56, 189, 248, 0.24),
    0 0 40px rgba(129, 140, 248, 0.16),
    inset 0 1px 0 rgba(255, 255, 255, 0.08);
  padding: 8px 0;
  border-radius: 12px;
  backdrop-filter: blur(14px);
}

.headerDropdownMenu::before {
  content: "";
  position: absolute;
  top: -42px;
  left: -20%;
  width: 140%;
  height: 64px;
  background: linear-gradient(90deg, transparent 0%, rgba(56, 189, 248, 0.18) 45%, transparent 100%);
  transform: rotate(-6deg);
  pointer-events: none;
}

.headerDropdownMenu::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  pointer-events: none;
}

.headerDropdownItem {
  color: rgba(226, 232, 240, 0.94);
  padding: 10px 16px;
  margin: 3px 8px;
  border-radius: 8px;
  transition: background 0.25s ease, transform 0.2s ease, box-shadow 0.25s ease;
  border-left: 3px solid transparent;
  border: 1px solid transparent;
  background: linear-gradient(90deg, rgba(15, 23, 42, 0.35) 0%, rgba(30, 41, 59, 0.2) 100%);
}

.headerDropdownItem:hover {
  background: linear-gradient(90deg, rgba(56, 189, 248, 0.22) 0%, rgba(129, 140, 248, 0.17) 100%);
  border-left-color: rgba(56, 189, 248, 0.85);
  border-color: rgba(56, 189, 248, 0.32);
  transform: translateX(4px);
  box-shadow: 0 0 14px rgba(56, 189, 248, 0.18), 0 0 20px rgba(129, 140, 248, 0.14);
}

.headerDropdownItem:active {
  background: linear-gradient(90deg, rgba(56, 189, 248, 0.3) 0%, rgba(129, 140, 248, 0.22) 100%);
  transform: translateX(2px) scale(0.99);
  box-shadow: 0 0 9px rgba(56, 189, 248, 0.28);
}

.headerDropdownItem .settingChooseTitle {
  color: rgba(191, 230, 255, 0.98);
  font-weight: 700;
}

.headerDropdownItem:hover .settingChooseTitle {
  color: #f0f9ff;
}

.headerDropdownItem .iconContainer {
  color: rgba(125, 211, 252, 0.95);
  filter: drop-shadow(0 0 6px rgba(56, 189, 248, 0.45));
}

.headerDropdownItem:hover .iconContainer {
  color: #e0f2fe;
  filter: drop-shadow(0 0 8px rgba(56, 189, 248, 0.7));
}

.headerDropdownItem .loginOutTitle {
  color: rgba(252, 165, 165, 0.96);
}

.headerDropdownItem:hover .loginOutTitle {
  color: #fecaca;
}

.headerDropdownItem.isDanger:hover {
  border-left-color: rgba(248, 113, 113, 0.85);
  border-color: rgba(248, 113, 113, 0.35);
  box-shadow: 0 0 14px rgba(248, 113, 113, 0.18), 0 0 20px rgba(248, 113, 113, 0.16);
}

.headerDropdownFade-enter-active,
.headerDropdownFade-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
  transform-origin: right top;
}

.headerDropdownFade-enter,
.headerDropdownFade-leave-to {
  opacity: 0;
  transform: translateY(-6px) scale(0.98);
}
</style>
